import * as t from "io-ts";
import * as util from "../../shared/src/util";

export const codec = t.union([t.literal("documents"), t.literal("emails")]);

type T = t.TypeOf<typeof codec>;

export const values = util.typeValuesFromCodec(codec.types as Array<t.LiteralC<T>>);
